/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { CustomText } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { offsetByExcelSelector } from 'src/features'
import { getFinalPrice } from 'src/features/developers/actions'
import { selectFinalUnitPrice } from 'src/features/developers/selectors'

const PurchaseEmissionColumn: React.FC<{ amount: string }> = ({ amount }) => {
  const { offsetKeys: { co2UnitField },
    preparePurchases: { selectedProjectId },
  } = useAppSelector(offsetByExcelSelector)
  const { total_amount: price } = useAppSelector(selectFinalUnitPrice)
  const dispatch = useAppDispatch()
  const unit = { KG: 'kgCO2', TONS: 'tCO2' }[co2UnitField]
  useEffect(() => {
    if (!unit && selectedProjectId) {
      dispatch(getFinalPrice())
    }
  }, [selectedProjectId])

  const getEmissionsFromCurrency = () => price && amount ? (+amount / price).toFixed(3) + ' tCO2' : '--'
  return <CustomText label={unit ? `${amount} ${unit}` : getEmissionsFromCurrency()} />
}

export default PurchaseEmissionColumn
